import { defineStore } from 'pinia';

export default defineStore('protectionPlanStore', () => {
  const selectedProtectionPlan = ref<Record<string, string>>({});

  return { selectedProtectionPlan };
});
